import { validAddressSchema } from '@/features/account/services/Addresses/schemas'
import { guestStoreSchema } from '@/features/account/services/GuestUser/schemas'
import { GuestDataStore } from '@/features/shared/constants/global'
import { defineCookie } from '@/features/shared/utils/defineCookie'

export const guestStoreCookie = defineCookie({
  name: GuestDataStore.STORE,
  schema: guestStoreSchema.optional(),
  fallback: undefined,
})

export const guestAddressCookie = defineCookie({
  name: GuestDataStore.ADDRESS,
  schema: validAddressSchema.optional(),
  fallback: undefined,
})
